import axios from './../http'

function query(data) {
    return axios.post('/sys/userLoginLog/query', data);
}

function get(id) {
    return axios.get('/sys/userLoginLog/get?id=' + id);
}

export default {
    query,
    get
}